import { Button } from '@thoughtspot/radiant-react/widgets/button/button';
import { IconID } from '@thoughtspot/radiant-react/widgets/icon';
import React from 'react';
export const SettingsButton = ({ onClick, ariaLabel, testId, }) => (React.createElement(Button, { icon: IconID.COG, type: "secondary", ariaLabel: ariaLabel, onClick: onClick, "data-testid": testId }));
//# sourceMappingURL=settings-button.js.map